export const environment = {
  production: false,
  // note that we run with test bankid here. Using prod is meaningless
  // and this will only be _end_user_
  authServiceUrl: 'https://borgo-test.kundkannedom.sparbankensyd.se/service',
  kycApiUrl: 'https://borgo-test.kundkannedom.sparbankensyd.se/api',
  signLink: 'https://bo-test.internal.sparbankensyd.se/kundk%C3%A4nnedom/uppdatera',
  domain: 'borgo-test.kundkannedom.sparbankensyd.se',
  testMode: true
}
